import { render, staticRenderFns } from "./video.vue?vue&type=template&id=0de10bce&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports